
import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';


const BPharmCoursePage: React.FC = () => {
  const courseData = {
    title: "Bachelor of Pharmacy",
    shortName: "B.Pharm",
    duration: "4 years",
    description: "A comprehensive undergraduate program in pharmaceutical sciences focusing on drug formulation, pharmaceutical chemistry, and healthcare delivery.",
    overview: "Bachelor of Pharmacy (B.Pharm) is a 4-year undergraduate professional degree program that focuses on pharmaceutical sciences, drug development, and healthcare. The program combines theoretical knowledge with practical training in drug formulation, pharmaceutical chemistry, pharmacology, and clinical practice. Students learn about drug discovery, manufacturing processes, quality control, and pharmaceutical business operations.",
    eligibility: [
      "12th grade with Physics, Chemistry, Biology/Mathematics (PCB/PCM)",
      "Minimum 50% aggregate marks (45% for SC/ST/OBC)",
      "Some institutions require entrance exams",
      "Age: 17-25 years (relaxation for reserved categories)"
    ],
    careerProspects: {
      roles: [
        "Pharmacist",
        "Drug Inspector", 
        "Research Scientist",
        "Quality Control Analyst",
        "Pharmaceutical Marketing",
        "Clinical Research Associate",
        "Regulatory Affairs Specialist",
        "Hospital Pharmacist"
      ],
      industries: [
        "Pharmaceutical Companies",
        "Hospitals and Healthcare",
        "Drug Testing Laboratories", 
        "Government Health Departments",
        "Research and Development",
        "Pharmaceutical Marketing",
        "Clinical Research Organizations",
        "Regulatory Bodies"
      ],
      averageSalary: "₹2,50,000 - ₹8,00,000 per year",
      topRecruiters: [
        "Sun Pharmaceutical",
        "Dr. Reddy's Laboratories",
        "Cipla Limited",
        "Lupin Pharmaceuticals",
        "Aurobindo Pharma",
        "Biocon Limited",
        "Apollo Hospitals",
        "Government Pharmaceutical Corporations"
      ]
    },
    curriculum: [
      {
        year: 1,
        subjects: [
          "Pharmaceutical Chemistry I",
          "Pharmaceutics I",
          "Pharmacognosy I", 
          "Human Anatomy & Physiology I",
          "Mathematics",
          "English Communication"
        ]
      },
      {
        year: 2, 
        subjects: [
          "Pharmaceutical Chemistry II",
          "Pharmaceutics II",
          "Pharmacognosy II",
          "Human Anatomy & Physiology II",
          "Pathophysiology",
          "Computer Applications"
        ]
      },
      {
        year: 3,
        subjects: [
          "Pharmaceutical Chemistry III",
          "Pharmaceutics III",
          "Pharmacology I",
          "Pharmaceutical Microbiology",
          "Pharmaceutical Jurisprudence",
          "Pharmaceutical Management"
        ]
      },
      {
        year: 4,
        subjects: [
          "Pharmaceutical Chemistry IV",
          "Pharmaceutics IV",
          "Pharmacology II",
          "Clinical Pharmacy",
          "Industrial Pharmacy",
          "Project Work & Dissertation"
        ]
      }
    ],
    admissionProcess: [
      "Complete 12th grade with required subjects",
      "Appear for state/national entrance exams (if required)",
      "Apply to colleges based on merit/entrance scores",
      "Participate in counseling process",
      "Document verification and seat allocation",
      "Fee payment and admission confirmation"
    ],
    topColleges: [
      { 
        name: "Jamia Hamdard University", 
        location: "New Delhi", 
        fees: "₹1,20,000/year",
        ranking: "1"
      },
      { 
        name: "Institute of Chemical Technology", 
        location: "Mumbai", 
        fees: "₹1,50,000/year",
        ranking: "2"
      },
      { 
        name: "National Institute of Pharmaceutical Education", 
        location: "Punjab", 
        fees: "₹2,00,000/year",
        ranking: "3"
      },
      { 
        name: "Manipal College of Pharmaceutical Sciences", 
        location: "Karnataka", 
        fees: "₹3,50,000/year",
        ranking: "4"
      },
      { 
        name: "Delhi Institute of Pharmaceutical Sciences", 
        location: "Delhi", 
        fees: "₹1,80,000/year",
        ranking: "5"
      },
      { 
        name: "JSS College of Pharmacy", 
        location: "Karnataka", 
        fees: "₹2,50,000/year",
        ranking: "6"
      }
    ],
    skills: [
      "Analytical and research skills",
      "Attention to detail and precision", 
      "Knowledge of pharmaceutical sciences",
      "Quality control and testing",
      "Communication and counseling skills",
      "Computer proficiency",
      "Problem-solving abilities",
      "Regulatory compliance knowledge"
    ],
    futureScope: "B.Pharm graduates have excellent career opportunities in the rapidly growing pharmaceutical industry. They can pursue higher studies like M.Pharm, MBA in Pharmaceutical Management, or specialize in areas like clinical research, regulatory affairs, or pharmaceutical marketing. The scope includes private practice, hospital pharmacy, pharmaceutical manufacturing, research and development, and government positions.",
    faqs: [
      {
        question: "What is the difference between B.Pharm and Pharm.D?",
        answer: "B.Pharm is a 4-year undergraduate degree focusing on pharmaceutical sciences, while Pharm.D is a 6-year doctoral program with more clinical pharmacy focus and direct patient care responsibilities."
      },
      {
        question: "Can I become a pharmacist after B.Pharm?",
        answer: "Yes, after completing B.Pharm, you need to register with the State Pharmacy Council to practice as a pharmacist. You can work in retail pharmacies, hospitals, or pharmaceutical companies."
      },
      {
        question: "What are the higher study options after B.Pharm?",
        answer: "After B.Pharm, you can pursue M.Pharm in various specializations, MBA in Pharmaceutical Management, Pharm.D, or even enter into research programs like PhD in Pharmaceutical Sciences."
      },
      {
        question: "Is B.Pharm a good career option?",
        answer: "Yes, B.Pharm offers excellent career prospects with the growing pharmaceutical industry in India. There are opportunities in manufacturing, research, quality control, marketing, and regulatory affairs with good salary packages."
      },
      {
        question: "What is the scope of B.Pharm in government jobs?",
        answer: "B.Pharm graduates can apply for government positions like Drug Inspector, Pharmacist in government hospitals, positions in pharmaceutical corporations, and various roles in health departments at state and central levels."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BPharmCoursePage;
